export const PRIMARY_BLACK = '#001138';
export const SECONDARY_BLACK = '#282829';
export const BLACK = 'rgba(0, 0, 0, 0.87)';
export const FORM_LABEL_COLOR = '#6A7186';
